export default __webpack_public_path__ + "static/media/logo-shape-hex.a716a069.svg";